// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as OrderStatus from "./OrderStatus.res.js";
import * as OrderEditForm from "./OrderEditForm.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as OrderMutations from "./OrderMutations.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderPageActions(props) {
  let onRequestCancelEdition = props.onRequestCancelEdition;
  let statuses = props.statuses;
  let id = props.id;
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  let canGoBack = match[0];
  let action = OrderStatus.toAction(statuses);
  let createOrder = OrderMutations.useCreate();
  let updateOrder = OrderMutations.useUpdate(id, undefined);
  let moveOrder = OrderMutations.useMove(id, action);
  let unarchive = OrderMutations.useUnarchive(id, undefined);
  let match$1 = statuses[0];
  if (props.edition) {
    return JsxRuntime.jsxs(Inline.make, {
      children: [
        JsxRuntime.jsx(OrderEditForm.CancelButton.make, {
          label: I18n.t("Discard"),
          onPress: () => {
            if (id !== undefined || !canGoBack) {
              return onRequestCancelEdition();
            } else {
              return onGoBack();
            }
          }
        }),
        JsxRuntime.jsx(OrderEditForm.SubmitButton.make, {
          label: I18n.t(Stdlib_Option.isNone(id) ? "Create draft" : "Save"),
          tone: "success",
          onSubmit: Stdlib_Option.isNone(id) ? createOrder : updateOrder
        })
      ],
      space: "small"
    });
  } else if (match$1 === "ARCHIVED") {
    return JsxRuntime.jsx(Button.make, {
      label: I18n.t("Unarchive"),
      tone: "brand",
      icon: "unarchive",
      onPress: () => {
        unarchive();
      }
    });
  } else if (match$1 === "DRAFT") {
    return JsxRuntime.jsx(OrderEditForm.SubmitButton.make, {
      label: I18n.t("Finalize"),
      tone: "brand",
      onSubmit: moveOrder
    });
  } else if (match$1 === "FINALIZED") {
    return JsxRuntime.jsx(OrderEditForm.SubmitButton.make, {
      label: I18n.t("Define as accepted"),
      tone: "brand",
      onSubmit: moveOrder
    });
  } else if (match$1 === "ACCEPTED") {
    return JsxRuntime.jsx(OrderEditForm.SubmitButton.make, {
      label: I18n.t("Start reception"),
      tone: "brand",
      onSubmit: moveOrder
    });
  } else if (match$1 === "RECEIVING") {
    return JsxRuntime.jsx(OrderEditForm.SubmitButton.make, {
      label: I18n.t("Finish reception"),
      tone: "brand",
      onSubmit: moveOrder
    });
  } else if (match$1 === "RECEIVED" && !OrderStatus.has(statuses, "PAID")) {
    return JsxRuntime.jsx(OrderEditForm.SubmitButton.make, {
      label: I18n.t("Define as paid"),
      icon: "tick",
      tone: "brand",
      onSubmit: moveOrder
    });
  } else {
    return null;
  }
}

let make = React.memo(OrderPageActions);

export {
  make,
}
/* make Not a pure module */
